import { Directive, HostBinding, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { LabelProps, labelStyles } from '@kite_aerolab/shared/components';

@Directive({
  selector: '[kiteLabel]',
  providers: [NgModel],
})
export class LabelDirective {
  @Input() isInvalid: boolean;
  @Input() isDisabled: boolean;
  @Input() size: LabelProps['size'];
  @Input() css: LabelProps['css'];

  @HostBinding('class')
  public get isError(): string {
    return labelStyles({ isInvalid: this.isInvalid, size: this.size, isDisabled: this.isDisabled, css: this.css })
      .className;
  }
}
